import { Box, Button } from '@mui/material'
import type React from 'react'
import { useContext, useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LanguageContext } from '../util/LanguageContext'

type SignageSortButtonProps = {
  initOrderby: string
  onSort: (orderby: string) => void
}

export const SignageSortButton: React.FC<SignageSortButtonProps> = props => {
  const { initOrderby, onSort } = props
  const auth = useAuth()
  // 登録日並び替え
  const [orderby, setOrderby] = useState(initOrderby)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const onClickHandler = (inputOrderby: string) => {
    if (orderby && inputOrderby !== orderby) {
      // console.log(
      //   `onClickHandler inputOrderby:${inputOrderby} orderby:${orderby}`
      // );
      setOrderby(inputOrderby)
      onSort(inputOrderby)
    }
  }

  useEffect(() => {
    if (initOrderby === 'asc' || initOrderby === 'desc') {
      if (initOrderby !== orderby) {
        // console.log(`useEffect initOrderby:${initOrderby} orderby:${orderby}`);
        setOrderby(initOrderby)
        // onSort(initOrderby);
      }
    }
    // console.log(` initOrderby:${initOrderby}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initOrderby, orderby])

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        disabled={auth.isDisable}
        onClick={() => onClickHandler('asc')}
        sx={{
          justifyContent: 'center',
          color: '#282828',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          textAlign: 'left',
          backgroundColor: orderby === 'asc' ? '#fff16f' : '#f5f5f5',
          '&:hover': {
            backgroundColor:
              orderby === 'asc' ? 'rgba(255, 241, 111, 0.8)' : 'rgba(245, 245, 245, 0.8)',
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '80px',
          borderTopLeftRadius: '40px',
          borderBottomLeftRadius: '40px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          '& .MuiSvgIcon-root': {
            fontSize: '32px',
          },
        }}
      >
        {translation['sort_order_ascending']}
      </Button>
      <Button
        disabled={auth.isDisable}
        onClick={() => onClickHandler('desc')}
        sx={{
          justifyContent: 'center',
          color: '#282828',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          textAlign: 'left',
          backgroundColor: orderby === 'desc' ? '#fff16f' : '#f5f5f5',
          '&:hover': {
            backgroundColor:
              orderby === 'desc' ? 'rgba(255, 241, 111, 0.8)' : 'rgba(245, 245, 245, 0.8)',
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '80px',
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px',
          borderTopRightRadius: '40px',
          borderBottomRightRadius: '40px',
          '& .MuiSvgIcon-root': {
            fontSize: '32px',
          },
        }}
      >
        {translation['sort_order_descending']}
      </Button>
    </Box>
  )
}
